// app/utils/navigator.ts

export interface NavigateOptions {
  replace?: boolean;
  state?: any;
}

// Define interface for the window object to satisfy TypeScript
declare global {
  interface Window {
    __NOVIOPUS_NAVIGATE__?: (path: string, options?: NavigateOptions) => void;
    // Update queue to store objects containing path and options
    __NOVIOPUS_NAV_QUEUE__?: { path: string; options?: NavigateOptions }[];
  }
}

// Initialize queue on window if not exists
if (!window.__NOVIOPUS_NAV_QUEUE__) {
  window.__NOVIOPUS_NAV_QUEUE__ = [];
}

export const setNavigate = (fn: (path: string, options?: NavigateOptions) => void) => {
  //console.log('[Navigator] Setting navigation function (Global)...');
  window.__NOVIOPUS_NAVIGATE__ = fn;
  
  const queue = window.__NOVIOPUS_NAV_QUEUE__ || [];

  if (queue.length > 0) {
    //console.log(`[Navigator] Flushing ${queue.length} queued items.`);
    // Process queue with a slight delay to ensure React Router is fully mounted
    setTimeout(() => {
        while (queue.length > 0) {
            const item = queue.shift();
            if (item && window.__NOVIOPUS_NAVIGATE__) {
                //console.log(`[Navigator] Processing queued route: ${item.path}`);
                window.__NOVIOPUS_NAVIGATE__(item.path, item.options);
            }
        }
    }, 100);
  }
};

export const navigateTo = (path: string, options?: NavigateOptions) => {
  if (window.__NOVIOPUS_NAVIGATE__) {
    //console.log(`[Navigator] Immediate push: ${path}`);
    window.__NOVIOPUS_NAVIGATE__(path, options);
  } else {
    //console.warn(`[Navigator] Queueing navigation: ${path}`);
    window.__NOVIOPUS_NAV_QUEUE__?.push({ path, options });
  }
};